<template>
	<div class="box-logo flex align-center" :class="{'nav-collapsed':collapseNav, [mode]:true}">
		<button class="collapse-nav" @click="collapseNavToggle">
			<!-- <i class="mdi mdi-menu"></i> -->
      <img src="@/assets/images/muen.png">
		</button>
		<div class="app-name" @click="goto('/')">
			<img src="@/assets/images/logo.png" width="100%" alt="logo"/>
		</div>
	</div>
</template>

<script>
export default {
  name: 'Logo',
  props: ['collapseNav', 'mode'],
  data () {
    return {}
  },
  methods: {
    collapseNavToggle () {
      this.$emit('collapse-nav-toggle')
    },
    goto (index, indexPath) {
      this.$router.push(index)
    }
  }
}
</script>

<style lang="scss">
.box-logo {
	height: 62px;
	background-color: #fff;
	box-sizing: border-box;
	font-size: 20px;
	font-weight: bold;
	position: relative;
	border-bottom: 2px solid #e5e5e5;
	.app-name {
		cursor: pointer;
		margin-left: 20px;
	}
	.app-name {
		img {
			vertical-align: middle;
      width: 88px;
		}
	}
	.collapse-nav {
		cursor: pointer;
		font-size: 20px;
		border: 1px solid #e0dddd;
		color: #FFD111;
		outline: none;
		background: #fff;
		transition: all .5s;
		margin-left: 20px;
	}
	&:hover {
		.collapse-nav {
			opacity: 1;
			left: 20px;
		}
	}
	&.nav-collapsed {
		.app-name {
			display: none;
		}
	}
	&.horizontal {
		height: 100%;

		.collapse-nav {
			display: none;
		}
	}
}

@media (max-width: 768px) {
	.box-logo {
		.collapse-nav {
			display: none;
		}

		&.horizontal {
			padding: 0 10px;

			.app-name {
				display: none;
			}
		}
	}

}
</style>
